import { SelectOption } from "../../../app/components/inputs/ControlledSelect";

export enum YouthRelationshipEnum {
  Mother = "Mother",
  Father = "Father",
  Grandparent = "Grandparent",
  Sibling = "Sibling",
  OtherAdultRelative = "OtherAdultRelative",
  LegalGuardian = "LegalGuardian",
  ProbationOfficer = "ProbationOfficer",
  SocialWorker = "SocialWorker",
  MentalHealthTherapist = "MentalHealthTherapist",
  Teacher = "Teacher",
  SchoolCounselor = "SchoolCounselor",
  Employer = "Employer",
  Parent = "Parent",
  Other = "Other",  
}

export const youthRelationshipextMap: { [key: string]: string } = {
  [YouthRelationshipEnum.Mother]: "Mother",
  [YouthRelationshipEnum.Father]: "Father",
  [YouthRelationshipEnum.Grandparent]: "Grandparent",
  [YouthRelationshipEnum.Sibling]: "Sibling",
  [YouthRelationshipEnum.OtherAdultRelative]: "Other Adult Relative",
  [YouthRelationshipEnum.LegalGuardian]: "Legal Guardian",
  [YouthRelationshipEnum.ProbationOfficer]: "Probation Officer",
  [YouthRelationshipEnum.SocialWorker]: "Social Worker",
  [YouthRelationshipEnum.MentalHealthTherapist]: "Mental Health Therapist",
  [YouthRelationshipEnum.Teacher]: "Teacher",
  [YouthRelationshipEnum.SchoolCounselor]: "School Counselor",
  [YouthRelationshipEnum.Employer]: "Employer",
  [YouthRelationshipEnum.Parent]: "Parent",
  [YouthRelationshipEnum.Other]: "Other",
};

export const getYouthRelationshipOptions = (includeLegacyOptions:boolean): SelectOption[] => {
  let keys = Object.keys(YouthRelationshipEnum);

  return [
    {
      value: "",
      label: "Select Relationship",
    },
    ...keys.map((status) => ({
      value: status,
      label: youthRelationshipextMap[status],
    })).filter((a) => includeLegacyOptions || a.value !== "Parent"),
  ];
};
